import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppLoader } from '@/containers';
import {
  useCheckAccessTokenOnDocumentFocus,
  usePersistUtmParameters,
  useSessionRecordings,
  useUrlRegion,
} from '@/hooks';
import { AnalyticsService } from '@/services';
import {
  checkForExistingTokens,
  selectSessionIsLoading,
  selectSessionUserId,
  useAppDispatch,
} from '@/store';
import { parseRedirectUrl } from '@/utils';

export const SessionLoader = () => {
  const dispatch = useAppDispatch();
  const sessionIsLoading = useSelector(selectSessionIsLoading);
  const userId = useSelector(selectSessionUserId);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(checkForExistingTokens());
  }, [dispatch]);

  useEffect(() => {
    if (sessionIsLoading) return;
    AnalyticsService.identify({ userId });

    if (userId) {
      const redirectUrl = parseRedirectUrl();
      const url = new URL(redirectUrl);
      navigate(`${url.pathname}${url.search}${url.hash}`, { replace: true });
    }
  }, [userId, sessionIsLoading, navigate]);

  useCheckAccessTokenOnDocumentFocus();

  usePersistUtmParameters();
  useUrlRegion();

  useSessionRecordings();

  return sessionIsLoading ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <CircularProgress />
    </Box>
  ) : (
    <AppLoader />
  );
};
